import { useMemo } from "react";
import { useStream } from "../context/StreamProvider";
import { useIsGroupCall } from "./useIsGroupCall";

/**
 * В личном звонке на главном экране показываем собеседника (даже если флаг currentVideo ещё на локальном превью).
 * В группе — кого выбрали (currentVideo).
 */
export function useEffectiveMainStream() {
  const { userStreams } = useStream();
  const isGroupCall = useIsGroupCall();

  return useMemo(() => {
    const streams = Object.values(userStreams);
    const withFlag = streams.find((s) => s.currentVideo);
    const remote = streams.find((s) => !s.isLocal);

    if (!isGroupCall && withFlag?.isLocal && remote) {
      return remote;
    }
    return withFlag;
  }, [userStreams, isGroupCall]);
}
